import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Слияние Tailwind-классов с разрешением конфликтов. */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
